import { CUSTOMER_ROLES } from 'store/insuranceAnketa/constants';

export const aggregateCustomerIDsByRole = ({ roles }) => {
  const defaultResult = Object.values(CUSTOMER_ROLES).reduce((acc, key) => {
    return { ...acc, [key]: new Map() };
  }, {});

  return roles.reduce((acc, role) => {
    const { customerId, roleSysName } = role;

    acc[roleSysName] ??= new Map();
    acc[roleSysName].set(customerId, role);

    return acc;
  }, defaultResult);
};
